
const FreeTextSection = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  return (
    <section className="py-5">
      <div className="container text-center">

        {/* Title */}
        <div className="row justify-content-center mb-4">
          <div className="col-12">
            <h3 className="text-black font-bold text-uppercase">
            Featured Case study
            </h3>
          </div>
        </div>

        {/* Description */}
        <div className="row mb-4 text-left">
          <div className="col-12">
            <p>
              As Brand Acumen we specialize in innovative brand name developement. Our linguistic experts employ theoretical approaches to model brand language in a way that clarifies intuitions about core meanings and explains our creativity behind words without confusion.            </p>
          </div>
        </div>
        <div className="card text-white img-radius overflow-hidden">
          <img src={`${awsImageBaseUrl}images/clients/Escalade_Case_Image.jpg`}  className="card-img img-radius card-img-feature" alt="Hero Background" />
          <div className="card-img-overlay hero-overlay card-gradient text-left ps-5">
            <h3 className="font-bold display-5 mb-4 text-shadow red-bottom-border pt-5 mt-5">
              <span className="mt-5">ESCALADE</span>
            </h3>
            <p>Brand name creation for Cadillac’s new luxury entrant <span className="d-none d-md-block"></span> to the otherwise rugged SUV market.</p>
          </div>
        </div>
        <div className="row">
        <div className="col">
          <p>Cadillac desired a name that would revitalize the Cadillac brand and develop a single identity that would redefine the SUV market.</p>
          <p>Through QualiQuantitative Interviews that specifically included 100 SUV dealers and 100 individuals who had owned an SUV for a minimum of three years, the following eight names were developed and evaluated:
          </p>
        </div>
      </div>
      </div>

    </section>
  );
};

export default FreeTextSection;
